import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M68.01 47.37L61.78 1.5H7.71002L1.47998 47.37C1.47998 47.37 11.47 67.14 34.59 56.24C55.9 65.98 68.01 47.37 68.01 47.37Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
